module.exports = __webpack_public_path__ + "img/c48ed8d.gif";